import type { ICommand } from '@/engine/app/modules/core/interfaces/Command';
import { injectable } from 'inversify';
import { BooleanTuneCommand } from './BooleanTune.command';
import type { BooleanTuner } from '../BooleanTuner';
import type { ITuneCommandFactory } from './interfaces';

@injectable()
export class BooleanTuneCommandsFactory implements ITuneCommandFactory<ICommand, BooleanTuner, boolean> {
  public createCommand(tuner: BooleanTuner, descriptor: string, val: boolean): ICommand {
    return new BooleanTuneCommand(tuner, descriptor, val);
  }
}
